import { useState, useEffect } from "react";
import BarGraph from "../UI/BarGraph";
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import LoaderGraph from "../UI/LoaderGraph";
import ExportCsvButton from "../UI/ExportCsvButton";
import { toTitleCase } from "../../util/format-text";
import { MdRefresh } from "react-icons/md";

/** ========================================================================
 * * Partner Revenue Graph
 * Renders a component, which displays all a graph.
 * ========================================================================== */

export default function PartnerRevenue({ partnerId }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [type, setType] = useState("distributed");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  // ============================================= FETCH REVENUE FOR VEHICLES
  const fetchRevenueHandler = async () => {
    try {
      setLoading(true);
      const data = await requestAdminAPI("fetch-partner-revenue", {
        year: selectedYear,
        type: type,
        partnerId,
      });
      setData(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (partnerId) fetchRevenueHandler();
  }, [selectedYear, partnerId, type]);

  return (
    <div>
      <Heading title="Partner Vehicles Revenue" isBackArrow={false}>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="distributed">Distributed</option>
          <option value="dateCreated">Date Created</option>
          <option value="datePaid">Date Paid</option>
        </select>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {Array.from(
            { length: new Date().getFullYear() - 2022 + 1 },
            (_, i) => {
              return (
                <option key={i} value={2022 + i}>
                  {2022 + i}
                </option>
              );
            }
          )}
        </select>
        <ExportCsvButton array={data} filename="partner-revenue" />
        <MdRefresh onClick={fetchRevenueHandler} className="icon" />
      </Heading>
      {loading ? <LoaderGraph /> : <BarGraph data={data} />}
    </div>
  );
}
